import { render, staticRenderFns } from "./NewModuleBloc.vue?vue&type=template&id=4d0c1992&scoped=true&"
import script from "./NewModuleBloc.vue?vue&type=script&lang=ts&"
export * from "./NewModuleBloc.vue?vue&type=script&lang=ts&"
import style0 from "./NewModuleBloc.vue?vue&type=style&index=0&id=4d0c1992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c1992",
  null
  
)

export default component.exports